const STORAGE_KEY = 'otter_device_landing_page';
const BREADCRUMB_SELECTORS = ['.breadcrumbs', '.b-blog-breadcrumbs', '.b-blog-post-breadcrumbs', '.section__breadcrumbs'];

class DeviceBackButton extends HTMLElement {
  connectedCallback() {
    const { storeName, storeUrl } = this.dataset;

    // On a device landing page: remember it, don't render a button here.
    if (storeName && storeUrl) {
      this.#remember(storeName, storeUrl);
      return;
    }

    this.#render();
  }

  /**
   * @param {string} name
   * @param {string} url
   */
  #remember(name, url) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({ name, url }));
    } catch {
      // sessionStorage unavailable (private browsing, etc.)
    }
  }

  #getRemembered() {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY) || 'null');
    } catch {
      return null;
    }
  }

  #render() {
    const data = this.#getRemembered();
    if (!data?.name || !data?.url) return;

    const link = this.querySelector('[data-role="link"]');
    const text = this.querySelector('[data-role="text"]');
    if (!(link instanceof HTMLAnchorElement) || !(text instanceof HTMLElement)) return;

    const template = Theme.translations?.back_to_device_landing_page || 'Back to __DEVICE__';
    text.textContent = template.replace('__DEVICE__', data.name);
    link.href = data.url;
    link.hidden = false;
    this.#hideBreadcrumbs();
  }

  #hideBreadcrumbs() {
    BREADCRUMB_SELECTORS.forEach((selector) => {
      document.querySelectorAll(selector).forEach((breadcrumb) => {
        const container = breadcrumb.closest('.section') || breadcrumb;
        if (!(container instanceof HTMLElement)) return;

        container.hidden = true;
        container.style.display = 'none';
      });
    });
  }
}

if (!customElements.get('device-back-button')) {
  customElements.define('device-back-button', DeviceBackButton);
}
